// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"Components_dimmer__2TMqC","loadingDimmer":"Components_loadingDimmer__1sRtq"};